import React, { FC } from 'react';

const Diagram: FC = () => (
  <svg width="480" viewBox="0 0 442.3 352.2" style={{ marginTop: 15 }}>
    <g id="fills">
      <path
        fill="#2E6AFF"
        d="M342.2,331c11.6,0,21-9.4,21-21V118.9c0-11.6-9.4-21-21-21s-21,9.4-21,21V310
    C321.1,321.6,330.5,331,342.2,331z"
      />
      <path
        fill="#2E6AFF"
        d="M224.9,236.3c11.6,0,21-9.4,21-21V71.6c0-11.6-9.4-21-21-21c-11.6,0-21,9.4-21,21v143.7
    C203.9,226.9,213.3,236.3,224.9,236.3z"
      />
      <path
        fill="#2E6AFF"
        d="M117.9,331c11.6,0,21-9.4,21-21V70.8c0-11.6-9.4-21-21-21s-21,9.4-21,21V310
    C96.9,321.6,106.3,331,117.9,331z"
      />
      <g className="fill-opaque">
        <circle cx="224.9" cy="71.6" r="11.6" />
        <circle cx="224.9" cy="166.3" r="11.6" />
        <circle cx="342.2" cy="118.9" r="11.6" />
        <circle cx="342.2" cy="213.7" r="11.6" />
        <circle cx="117.9" cy="308.4" r="11.6" />
      </g>
    </g>
    <g id="strokes">
      <g>
        <circle
          className="fill-opaque stroke-border"
          strokeWidth="3"
          cx="342.2"
          cy="166.3"
          r="11.6"
        />
        <line
          className="fill-none stroke-border"
          strokeWidth="3"
          x1="330.6"
          y1="166.3"
          x2="249.8"
          y2="166.3"
        />
        <polyline
          className="fill-none stroke-border"
          strokeWidth="3"
          points="259.9,154.8 248.3,166.3 259.9,177.9 		
      "
        />
      </g>
      <g>
        <circle
          className="fill-opaque stroke-border"
          strokeWidth="3"
          cx="342.2"
          cy="308.4"
          r="11.6"
        />
        <line
          className="stroke-border"
          strokeWidth="3"
          x1="330.6"
          y1="308.4"
          x2="143.4"
          y2="308.4"
        />
        <polyline
          className="fill-none stroke-border"
          strokeWidth="3"
          points="153.5,296.8 141.9,308.4 153.5,320 		"
        />
      </g>
      <g>
        <circle
          className="fill-opaque stroke-border"
          strokeWidth="3"
          cx="224.9"
          cy="213.7"
          r="11.6"
        />
        <line
          className="stroke-border"
          strokeWidth="3"
          x1="236.5"
          y1="213.7"
          x2="316.7"
          y2="213.7"
        />
        <polyline
          className="fill-none stroke-border"
          strokeWidth="3"
          points="306.6,202.1 318.1,213.7 306.6,225.2 		
      "
        />
      </g>
      <g>
        <circle
          className="fill-opaque stroke-border"
          strokeWidth="3"
          cx="224.9"
          cy="118.9"
          r="11.6"
        />
        <line
          className="stroke-border"
          strokeWidth="3"
          x1="236.5"
          y1="118.9"
          x2="316.7"
          y2="118.9"
        />
        <polyline
          className="fill-none stroke-border"
          strokeWidth="3"
          points="306.6,107.4 318.1,119 306.6,130.5 		"
        />
      </g>
      <g>
        <circle
          className="fill-opaque stroke-border"
          strokeWidth="3"
          cx="117.9"
          cy="71.6"
          r="11.6"
        />
        <line
          className="stroke-border"
          strokeWidth="3"
          x1="129.5"
          y1="71.6"
          x2="199.9"
          y2="71.6"
        />
        <polyline
          className="fill-none stroke-border"
          strokeWidth="3"
          points="189.8,83.1 201.4,71.6 189.8,60 		"
        />
      </g>
      <rect x="140.2" y="33.9" fill="none" width="93.1" height="18" />
      <g className="fill-foreground">
        <text
          transform="matrix(1 0 0 1 140.2041 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          a
        </text>
        <text
          transform="matrix(1 0 0 1 148.9073 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          u
        </text>
        <text
          transform="matrix(1 0 0 1 157.7276 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          t
        </text>
        <text
          transform="matrix(1 0 0 1 162.9541 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          h
        </text>
        <text
          transform="matrix(1 0 0 1 171.7666 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          o
        </text>
        <text
          transform="matrix(1 0 0 1 180.8916 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          r
        </text>
        <text
          transform="matrix(1 0 0 1 186.3057 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          i
        </text>
        <text
          transform="matrix(1 0 0 1 190.1885 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          z
        </text>
        <text
          transform="matrix(1 0 0 1 197.9932 45.8941)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          e
        </text>
        <rect x="267.6" y="91" fill="none" width="40.7" height="18.8" />
        <text
          transform="matrix(1 0 0 1 267.6279 102.9778)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          code
        </text>
        <rect x="267.6" y="140.2" fill="none" width="40.7" height="18.8" />
        <text
          transform="matrix(1 0 0 1 267.6279 152.2419)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          code
        </text>
        <rect x="267.6" y="184.8" fill="none" width="40.7" height="18.8" />
        <text
          transform="matrix(1 0 0 1 267.6279 196.8141)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          t
        </text>
        <text
          transform="matrix(1 0 0 1 272.6982 196.8141)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          o
        </text>
        <text
          transform="matrix(1 0 0 1 281.8232 196.8141)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          k
        </text>
        <text
          transform="matrix(1 0 0 1 289.7763 196.8141)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          e
        </text>
        <text
          transform="matrix(1 0 0 1 298.2529 196.8141)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          n
        </text>
        <rect x="160.9" y="279" fill="none" width="56.3" height="18" />
        <text
          transform="matrix(1 0 0 1 160.8886 291.0418)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          cookie
        </text>
        <rect x="85.5" y="6.5" fill="none" width="66.5" height="14.9" />
      </g>
      <g className="fill-background">
        <text
          transform="matrix(1 0 0 1 86.9971 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          F
        </text>
        <text
          transform="matrix(1 0 0 1 95.6377 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          r
        </text>
        <text
          transform="matrix(1 0 0 1 100.8955 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          o
        </text>
        <text
          transform="matrix(1 0 0 1 110.0205 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          n
        </text>
        <text
          transform="matrix(1 0 0 1 118.8486 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          t
        </text>
        <text
          transform="matrix(1 0 0 1 124.0752 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          e
        </text>
        <text
          transform="matrix(1 0 0 1 132.5517 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          n
        </text>
        <text
          transform="matrix(1 0 0 1 141.3799 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          d
        </text>
        <rect x="195.7" y="6.5" fill="none" width="66.5" height="14.9" />
        <text
          transform="matrix(1 0 0 1 199.5047 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          P
        </text>
        <text
          transform="matrix(1 0 0 1 209.5984 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          r
        </text>
        <text
          transform="matrix(1 0 0 1 214.8562 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          o
        </text>
        <text
          transform="matrix(1 0 0 1 223.8641 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          v
        </text>
        <text
          transform="matrix(1 0 0 1 231.6141 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          i
        </text>
        <text
          transform="matrix(1 0 0 1 235.4969 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          d
        </text>
        <text
          transform="matrix(1 0 0 1 244.5203 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          e
        </text>
        <text
          transform="matrix(1 0 0 1 252.9969 18.5107)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          r
        </text>
        <rect x="300.3" y="6.5" fill="none" width="83.7" height="16.9" />
        <text
          transform="matrix(1 0 0 1 311.4951 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          B
        </text>
        <text
          transform="matrix(1 0 0 1 321.4561 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          a
        </text>
        <text
          transform="matrix(1 0 0 1 330.1592 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          c
        </text>
        <text
          transform="matrix(1 0 0 1 338.5342 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          k
        </text>
        <text
          transform="matrix(1 0 0 1 346.4873 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          e
        </text>
        <text
          transform="matrix(1 0 0 1 354.9639 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          n
        </text>
        <text
          transform="matrix(1 0 0 1 363.792 18.5103)"
          fontFamily="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
          fontSize="16px"
        >
          d
        </text>
      </g>
    </g>
  </svg>
);

export default Diagram;
